import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const ScrollToTop = () => {
    const { pathname, hash } = useLocation()

    useEffect(() => {
        if (hash) {
            // If there's a hash, scroll to the element
            const hashId = hash.substring(1)
            const scrollToElement = () => {
                const element = document.getElementById(hashId)
                if (element) {
                    // Get header height (80px on desktop, but check if it's sticky)
                    const header = document.querySelector('.header')
                    const isSticky =
                        header &&
                        window.getComputedStyle(header).position === 'sticky'
                    const headerOffset = isSticky ? 100 : 0 // Add extra padding for better visibility

                    const elementPosition =
                        element.getBoundingClientRect().top + window.pageYOffset
                    const offsetPosition = elementPosition - headerOffset

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth',
                    })
                    return true
                }
                return false
            }

            // Try immediately
            if (scrollToElement()) {
                return
            }

            // Retry with increasing delays to wait for markdown/content to render
            let attempts = 0
            const maxAttempts = 10
            const retryInterval = setInterval(() => {
                attempts++
                if (scrollToElement() || attempts >= maxAttempts) {
                    clearInterval(retryInterval)
                }
            }, 100)

            return () => clearInterval(retryInterval)
        } else {
            // If no hash, scroll to top
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            })
        }
    }, [pathname, hash])

    return null
}

export default ScrollToTop
